import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";


const BackupSlider = (props) => {
    const { backupId, backupObj, updateKey, closeSlider } = props;

    const [editLoader, setEditLoader] = useState("none");
    const [editOpacity, setEditOpacity] = useState(1);

    const [backup, setBackup] = useState("");
    const [backupDesc, setBackupDesc] = useState("");


    useEffect(() => {
        // console.log("BackupSlider called");
        if (!backupId || backupId === 0) {
            setBackup("");
            setBackupDesc("");
        } else {
            setBackup(backupObj.backup);
            setBackupDesc(backupObj.backupNotes);
        }
    }, [backupId, backupObj]);

    const saveBackup = () => {
        if (!backup) {
            toast.error("enter a backup name.");
            return;
        }
        if (!backupDesc) {
            toast.error("enter a backup description.");
            return;
        }

        // console.log("saveFacility called");
        const backupObj = {
            backupId: backupId || 0,
            backup: backup,
            backupNotes: backupDesc
        };

        setEditLoader("block");
        setEditOpacity(0.5);
        // saveBackupSvc(backupObj, saveBackupResponse);
    };


    const saveBackupResponse = async (data) => {
        // console.log("saveBackupResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
            await updateKey();
            closeSlider();
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setEditLoader("none");
        setEditOpacity(1);
    }

    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };


    return (
        <div >
            <button type="button" className='btn btn-info text-center btnCloseDiv' onClick={() => closeSlider()} style={{ right: "60%" }}>
                <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
            </button>
            <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '58%', top: '45%', display: editLoader }}>
                <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
            </div>
            <div className="col-md-12 col-xs-12 col-centered padding-remove "
                style={{
                    cursor: (editLoader === "none") ? 'pointer' : 'none',
                    pointerEvents: (editLoader === "none") ? 'auto' : 'none',
                    opacity: editOpacity
                }}>
                <div className="col-sm-12 col-md-12 padding-remove"
                    style={{ width: '94%', margin: '3% ', background: '#fff', border: '1px solid #ccc', borderRadius: 10 }}>
                    <form
                        id="editFacilityForm"
                        className='form form-horizontal'
                        style={{ height: "300px", overflowX: 'hidden', padding: "20px 20px 5px 20px", }}
                    >
                        <div className="form-group col-md-12 " style={{ padding: "5px 0" }}>
                            <div className="form-group col-md-12 padding-remove">
                                <label className="control-label col-md-4 col-xs-6 " style={{ padding: "7px 0 0 0" }}>
                                    Backup Name:
                                </label>
                                <div className='col-md-6 col-sm-6 col-xs-12  '>
                                    <input
                                        type="text"
                                        className="form-control"
                                        maxLength={20}
                                        value={backup}
                                        onChange={(e) => setBackup(e.target.value)}
                                        placeholder='Enter a name for the backup...'
                                        disabled={backupId !== 0 ? true : false}
                                    ></input>
                                </div>
                            </div>
                            <div className="form-group col-md-12 padding-remove">
                                <label className="control-label col-md-4 col-xs-6 " style={{ padding: "7px 0 0 0" }}>
                                    Backup Description:
                                </label>
                                <div className='col-md-6 col-sm-6 col-xs-12  '>
                                    <textarea
                                        className="form-control"
                                        maxLength={100}
                                        value={backupDesc}
                                        onChange={(e) => setBackupDesc(e.target.value)}
                                        placeholder='Enter backup description here...'
                                        rows="3"
                                        disabled={backupId !== 0 ? true : false}
                                    ></textarea>
                                </div>
                            </div>


                            <div className='col-sm-10   padding-remove' style={{ height: "50px", marginTop: "80px" }}>
                                <div className="col-sm-2 col-md-2  padding-remove pull-right">
                                    <button
                                        disabled={backupId !== 0 ? true : false}
                                        type="button"
                                        className="btn btn-info "
                                        onClick={() => saveBackup()} >Save</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div >
    );
}

export default BackupSlider;

